import PerfilInversorFormulario from "../forms/PerfilInversor";
import PerfilInversorPdf from "../forms/PerfilInversor/Pdf";

const Formularios = [
  { path: "/perfil-inversor/pdf/:hash", component: PerfilInversorPdf },
  { path: "/perfil-inversor/:hash", component: PerfilInversorFormulario },
];

export default Formularios;
